/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 27);
/******/ })
/************************************************************************/
/******/ ({

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_selectable_inventories__ = __webpack_require__(28);

jQuery(function ($) {
    window['$'] = $;
    new __WEBPACK_IMPORTED_MODULE_0__components_selectable_inventories__["a" /* default */]();
});


/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SelectableInventories = (function () {
    function SelectableInventories() {
        if ($('body').hasClass('single-product')) {
            this.$selectableDropdown = $('.atum-select-mi');
            if (this.$selectableDropdown.length) {
                this.doSelectableDropDownUI();
            }
        }
        this.$selectableList = $('.atum-select-mi-list');
        if (this.$selectableList.length) {
            this.doSelectableListUI();
        }
        this.$cart = $('.woocommerce-cart-form');
        if (this.$cart.length) {
            this.doSelectableCartItems();
        }
        this.$variationsForm = $('.variations_form');
        if (this.$variationsForm.length) {
            this.doSelectableVariations();
        }
    }
    SelectableInventories.prototype.doSelectableDropDownUI = function () {
        var $cartForm = this.$selectableDropdown.closest('form'), $productQtyInput = $cartForm.find('[name="quantity"]');
        this.$selectableDropdown.on('change', function (evt) {
            var $dropdown = $(evt.currentTarget), max = parseFloat($dropdown.find('option:selected').data('max'));
            $productQtyInput.attr('max', max);
            if (parseFloat($productQtyInput.val()) > max) {
                $productQtyInput.val(max);
            }
        }).change();
    };
    SelectableInventories.prototype.doSelectableListUI = function () {
        var $cartForm = this.$selectableList.closest('form'), $productQtyInput = $cartForm.find('[name="quantity"]').prop('readonly', true), $invQtyInput = $cartForm.find('[name^="atum[select-mi]"]'), $multiPriceWrapper = $cartForm.find('.atum-select-mi-list__multi-price');
        $invQtyInput.change(function () {
            var qty = 0, prices = [];
            $invQtyInput.each(function (index, elem) {
                var $elem = $(elem), $item = $elem.closest('.atum-select-mi-list__item'), currentQty = parseFloat($elem.val());
                qty += currentQty;
                if (currentQty > 0 && $item.find('.woocommerce-Price-amount').length) {
                    prices.push(currentQty + " x " + $item.find('.woocommerce-Price-amount').text());
                }
            });
            $productQtyInput.val(qty);
            if ($multiPriceWrapper.length) {
                $multiPriceWrapper.text(prices.join(' + '));
                $cartForm.find(':submit').prop('disabled', !prices.length);
            }
        });
        if ($multiPriceWrapper.length) {
            $invQtyInput.first().change();
        }
    };
    SelectableInventories.prototype.doSelectableCartItems = function () {
        $('body').on('change', '.woocommerce-cart-form .atum-mi-qty', function (evt) {
            var $invQtyInput = $(evt.currentTarget);
            var itemQty = parseFloat($invQtyInput.val()), $invRow = $invQtyInput.closest('.atum-mi-cart-item'), $currentRow = $invRow.prev(), $productRow;
            while ($currentRow.length && $currentRow.hasClass('atum-mi-cart-item')) {
                itemQty += parseFloat($currentRow.find('.atum-mi-qty').val());
                $currentRow = $currentRow.prev();
            }
            $productRow = $currentRow;
            $currentRow = $invRow.next();
            while ($currentRow.length && $currentRow.hasClass('atum-mi-cart-item')) {
                itemQty += parseFloat($currentRow.find('.atum-mi-qty').val());
                $currentRow = $currentRow.next();
            }
            if ($productRow.length) {
                $productRow.find('.quantity :input').val(itemQty);
            }
        });
    };
    SelectableInventories.prototype.doSelectableVariations = function () {
        var _this = this;
        var $singleVariation = this.$variationsForm.find('.single_variation');
        $singleVariation.on('show_variation', function (evt, variation, purchasable) {
            _this.$variationsForm.find('[name="quantity"]').removeAttr('readonly');
            if (variation && variation.hasOwnProperty('atum_mi_selectable')) {
                $singleVariation.append(variation.atum_mi_selectable);
                _this.$selectableList = $('.atum-select-mi-list');
                if (_this.$selectableList.length) {
                    _this.doSelectableListUI();
                }
            }
        });
    };
    return SelectableInventories;
}());
/* harmony default export */ __webpack_exports__["a"] = (SelectableInventories);


/***/ })

/******/ });


// WEBPACK FOOTER //
// atum-mi-selectable.js